export default function CTAAppel() {
  return (
    <section className="bg-brand-blue py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          Besoin d'une intervention dans le Bas-Rhin ?
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto">
          Nos techniciens sont disponibles pour tous vos besoins de réparation, motorisation et pose de volet roulant.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
          <a
            href="tel:0374473240"
            className="bg-brand-cyan text-white px-8 py-3.5 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line mr-2"></i></span>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="border-2 border-white text-white px-8 py-3.5 rounded-full font-semibold text-base hover:bg-white hover:text-brand-blue transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}